import { render } from "./StartMenejar.vue?vue&type=template&id=2112b6f0"
import script from "./StartMenejar.vue?vue&type=script&lang=js"
export * from "./StartMenejar.vue?vue&type=script&lang=js"

import "./StartMenejar.vue?vue&type=style&index=0&id=2112b6f0&lang=css"
import "./StartMenejar.vue?vue&type=style&index=1&id=2112b6f0&lang=css"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__